import * as stylex from "@stylexjs/stylex";
/**
 * Images referenced by name from MDX (`<FocusImage src="…" />`). Add an entry here
 * when adding a new file to assets/focus/.
 */ const focusImages = {
    "0-fig_1.png": new URL("../../assets/focus/0-fig_1.png", import.meta.url).href,
    "1-demand_1.png": new URL("../../assets/focus/1-demand_1.png", import.meta.url).href,
    "10-Early_entry_1.png": new URL("../../assets/focus/10-Early_entry_1.png", import.meta.url).href,
    "10-Early_entry_2.png": new URL("../../assets/focus/10-Early_entry_2.png", import.meta.url).href,
    "11-Adult_education_1.png": new URL("../../assets/focus/11-Adult_education_1.png", import.meta.url).href,
    "11-Adult_education_2.png": new URL("../../assets/focus/11-Adult_education_2.png", import.meta.url).href,
    "12-Low_performance_1.png": new URL("../../assets/focus/12-Low_performance_1.png", import.meta.url).href,
    "12-Low_performance_2.png": new URL("../../assets/focus/12-Low_performance_2.png", import.meta.url).href,
    "12-Low_performance_3.png": new URL("../../assets/focus/12-Low_performance_3.png", import.meta.url).href,
    "13-spending_1.png": new URL("../../assets/focus/13-spending_1.png", import.meta.url).href,
    "14-householdwealth_1.png": new URL("../../assets/focus/14-householdwealth_1.png", import.meta.url).href,
    "14-householdwealth_2.png": new URL("../../assets/focus/14-householdwealth_2.png", import.meta.url).href,
    "14-householdwealth_3.png": new URL("../../assets/focus/14-householdwealth_3.png", import.meta.url).href,
    "15-taxrevenue_1.png": new URL("../../assets/focus/15-taxrevenue_1.png", import.meta.url).href,
    "15-taxrevenue_2_1.png": new URL("../../assets/focus/15-taxrevenue_2_1.png", import.meta.url).href,
    "15-taxrevenue_2_2.png": new URL("../../assets/focus/15-taxrevenue_2_2.png", import.meta.url).href,
    "15-taxrevenue_3.png": new URL("../../assets/focus/15-taxrevenue_3.png", import.meta.url).href,
    "17-studentdebt_1.png": new URL("../../assets/focus/17-studentdebt_1.png", import.meta.url).href,
    "17-studentdebt_2.png": new URL("../../assets/focus/17-studentdebt_2.png", import.meta.url).href,
    "18-climatechange.png": new URL("../../assets/focus/18-climatechange.png", import.meta.url).href,
    "19-numeracyskills_1.png": new URL("../../assets/focus/19-numeracyskills_1.png", import.meta.url).href,
    "19-numeracyskills_2.png": new URL("../../assets/focus/19-numeracyskills_2.png", import.meta.url).href,
    "2-Teaching_outof_field_1.png": new URL("../../assets/focus/2-Teaching_outof_field_1.png", import.meta.url).href,
    "2-Teaching_outof_field_2.png": new URL("../../assets/focus/2-Teaching_outof_field_2.png", import.meta.url).href,
    "20-computationalthinking_1.png": new URL("../../assets/focus/20-computationalthinking_1.png", import.meta.url).href,
    "20-computationalthinking_2.png": new URL("../../assets/focus/20-computationalthinking_2.png", import.meta.url).href,
    "21-writingtools.png": new URL("../../assets/focus/21-writingtools.png", import.meta.url).href,
    "22-microcredentials.png": new URL("../../assets/focus/22-microcredentials.png", import.meta.url).href,
    "23-firstgeneration.png": new URL("../../assets/focus/23-firstgeneration.png", import.meta.url).href,
    "24-readingspeed_1.png": new URL("../../assets/focus/24-readingspeed_1.png", import.meta.url).href,
    "24-readingspeed_2.png": new URL("../../assets/focus/24-readingspeed_2.png", import.meta.url).href,
    "25-schoolbuilding.png": new URL("../../assets/focus/25-schoolbuilding.png", import.meta.url).href,
    "26-solarenergy.png": new URL("../../assets/focus/26-solarenergy.png", import.meta.url).href,
    "27-onlinesearch_1.png": new URL("../../assets/focus/27-onlinesearch_1.png", import.meta.url).href,
    "27-onlinesearch_2.png": new URL("../../assets/focus/27-onlinesearch_2.png", import.meta.url).href,
    "28-mathanxiety.png": new URL("../../assets/focus/28-mathanxiety.png", import.meta.url).href,
    "29-ecce_leaders.png": new URL("../../assets/focus/29-ecce_leaders.png", import.meta.url).href,
    "3-School_calendar_1.png": new URL("../../assets/focus/3-School_calendar_1.png", import.meta.url).href,
    "30-teach_leadership.png": new URL("../../assets/focus/30-teach_leadership.png", import.meta.url).href,
    "31-peer_effects.png": new URL("../../assets/focus/31-peer_effects.png", import.meta.url).href,
    "32-civic_edu-1.png": new URL("../../assets/focus/32-civic_edu-1.png", import.meta.url).href,
    "32-civic_edu-2.png": new URL("../../assets/focus/32-civic_edu-2.png", import.meta.url).href,
    "33-climate_infra.png": new URL("../../assets/focus/33-climate_infra.png", import.meta.url).href,
    "34-NSA_scholarships.png": new URL("../../assets/focus/34-NSA_scholarships.png", import.meta.url).href,
    "35-teacher_shortage.png": new URL("../../assets/focus/35-teacher_shortage.png", import.meta.url).href,
    "36-principal_salaries-1.png": new URL("../../assets/focus/36-principal_salaries-1.png", import.meta.url).href,
    "36-principal_salaries-2.png": new URL("../../assets/focus/36-principal_salaries-2.png", import.meta.url).href,
    "36-principal_salaries-3.png": new URL("../../assets/focus/36-principal_salaries-3.png", import.meta.url).href,
    "36-principal_salaries-4.png": new URL("../../assets/focus/36-principal_salaries-4.png", import.meta.url).href,
    "36-principal_salaries-5.png": new URL("../../assets/focus/36-principal_salaries-5.png", import.meta.url).href,
    "37-climate_fin.png": new URL("../../assets/focus/37-climate_fin.png", import.meta.url).href,
    "4-Singlesex_schools_1.png": new URL("../../assets/focus/4-Singlesex_schools_1.png", import.meta.url).href,
    "5-Infrastructure_1.png": new URL("../../assets/focus/5-Infrastructure_1.png", import.meta.url).href,
    "5-Infrastructure_2.png": new URL("../../assets/focus/5-Infrastructure_2.png", import.meta.url).href,
    "6-Learningnotlinear_1.png": new URL("../../assets/focus/6-Learningnotlinear_1.png", import.meta.url).href,
    "7-Safe_schools_1.png": new URL("../../assets/focus/7-Safe_schools_1.png", import.meta.url).href,
    "8-ScholarshipsSSA_1.png": new URL("../../assets/focus/8-ScholarshipsSSA_1.png", import.meta.url).href,
    "9-Indigenous_1.png": new URL("../../assets/focus/9-Indigenous_1.png", import.meta.url).href
};
/**
 *
 * This is an early draft of a component that will be used to display images in the focus pages.
 * Sizing implementation is currently naive and will be improved to work for mobile.
 */ export function FocusImage({ src, alt, href, size = "large" }) {
    const url = focusImages[src];
    if (!url) {
        console.error(`FocusImage: unknown image "${src}"`);
        return null;
    }
    return <div className="x2b8uid xfd2ba4">
      <a href={href} target="_blank" rel="noreferrer">
        <img {...stylex.props(styles.img, styles[`img-${size}`])} src={url} alt={alt}/>
      </a>
    </div>;
}
const styles = {
    root: {
        k9WMMc: "x2b8uid",
        kogj98: "xfd2ba4",
        $$css: true
    },
    img: {
        ks0D6T: "x193iq5w",
        $$css: true
    },
    "img-auto": {
        kzqmXN: "x14atkfc",
        $$css: true
    },
    "img-small": {
        kzqmXN: "xg0jo4d",
        $$css: true
    },
    "img-large": {
        kzqmXN: "xh8yej3",
        $$css: true
    }
};
